export type TranslationFileName =
  | "common"
  | "donationForm"
  | "ticketing"
  | "dashboard"
  | "ticketScan"
  | "campaignHub"
  | "organization"
  | "register";

// dashboard.json is ~0.9 MB per locale and lands in the page data of every prerendered page that loads it,
// so pages opt in with DASHBOARD_TRANSLATION_FILES. pageTranslationNamespaces.spec.ts enforces the choice.
export const DEFAULT_TRANSLATION_FILES: TranslationFileName[] = ["common", "donationForm", "ticketing"];

export const DASHBOARD_TRANSLATION_FILES: TranslationFileName[] = [...DEFAULT_TRANSLATION_FILES, "dashboard"];

export const DASHBOARD_PAGE_TRANSLATION_FILES: TranslationFileName[] = [
  ...DASHBOARD_TRANSLATION_FILES,
  "campaignHub",
  "organization",
];
